if (!customElements.get('papos-mobile-search')) {
  customElements.define(
    'papos-mobile-search',
    class extends HTMLElement {
      connectedCallback() {
        this.onLaunchClick = this.onLaunchClick || this.openSearch.bind(this);
        document.addEventListener('click', this.onLaunchClick, true);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onLaunchClick, true);
      }

      openSearch(event) {
        if (
          !window.matchMedia('(max-width: 749px)').matches ||
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        const link = event.target.closest('a');
        if (!link) return;

        const isLauncher = this.contains(link) && link.hasAttribute('data-pp-search-launch');
        const isBottomSearch =
          link.matches('.papos-mobile-nav a') &&
          link.href === new URL(this.dataset.searchUrl, window.location.origin).href;
        if (!isLauncher && !isBottomSearch) return;

        const modal = Array.from(this.closest('.header-wrapper').querySelectorAll('details-modal.pp-search-modal')).find(
          (element) => element.getClientRects().length > 0
        );
        const summary = modal?.querySelector('summary');
        if (!summary || typeof modal.open !== 'function') return;

        event.preventDefault();
        event.stopPropagation();
        const drawer = this.closest('.header-wrapper').querySelector('header-drawer');
        const menuSummary = drawer?.querySelector('details[open] > summary');
        if (menuSummary && typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer(event, menuSummary);
          menuSummary.setAttribute('aria-expanded', 'false');
        }
        if (!modal.isOpen()) summary.click();
      }
    }
  );
}
